module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page attendee-page attendee-add-page",
    staticStyle: {
      "padding-top": "0px",
      "min-height": "100%"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('img', {
    staticClass: "site-logo",
    attrs: {
      "src": "/static/images/nav_logo_white.png"
    }
  })]), _vm._v(" "), _c('form', {
    staticClass: "mx-2 pa-3",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attendee.full_name),
      expression: "attendee.full_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "my-2",
    attrs: {
      "type": "text",
      "placeholder": "Full Name",
      "name": "full_name"
    },
    domProps: {
      "value": (_vm.attendee.full_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attendee, "full_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attendee.username),
      expression: "attendee.username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "my-2",
    attrs: {
      "type": "text",
      "placeholder": "Artist / Brand / Label Name",
      "name": "display_name"
    },
    domProps: {
      "value": (_vm.attendee.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attendee, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attendee.email),
      expression: "attendee.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "my-2",
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.attendee.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attendee, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "my-2",
    attrs: {
      "items": _vm.account_types,
      "item-text": "name",
      "item-value": "id",
      "name": "account_type",
      "label": "- Select Account Type -",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.attendee.account_type),
      callback: function($$v) {
        _vm.$set(_vm.attendee, "account_type", $$v)
      },
      expression: "attendee.account_type"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attendee.referred_by),
      expression: "attendee.referred_by"
    }],
    staticClass: "my-2",
    attrs: {
      "type": "text",
      "placeholder": "Referred By",
      "name": "referred_by"
    },
    domProps: {
      "value": (_vm.attendee.referred_by)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attendee, "referred_by", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0 mt-2",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue",
      "type": "submit"
    }
  }, [_vm._v("Reserve My Account")])], 1)])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "content-class": "attendee-confirm-dialog"
    },
    model: {
      value: (_vm.show_attendee_confirm_dialog),
      callback: function($$v) {
        _vm.show_attendee_confirm_dialog = $$v
      },
      expression: "show_attendee_confirm_dialog"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-3": ""
    }
  }, [_c('div', {
    staticClass: "mt-5"
  }, [_c('img', {
    staticClass: "site-logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "width": "50px",
      "margin": "30px auto 50px auto"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('img', {
    staticClass: "page-logo",
    attrs: {
      "src": "/static/images/ic_verified.png"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("We’re launching soon!")]), _vm._v(" "), _c('p', [_vm._v("\n          You will receive an e-mail with a sign up"), _c('br'), _vm._v("\n          link to your pre-verifed account.\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f5effa6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/add_attendee.vue
// module id = 1767
// module chunks = 180